import axiosInstance from "./axiosInstance";


// const {authTokens, setAuthTokens} = useContext(AuthContext)

const refetchToken = async (token) => {
    const payload = {
        "refresh": token
    }
    const response = await axiosInstance.post(
        `/api/token/refresh/`,
        payload,
    );
    return response;
};

export default refetchToken